export default "__VITE_ASSET__hi1BS3QM__"